import {
  getIsOdd,
  getIsOnlyReadElement,
  getTaskFromLookahead
} from '../common/validators';
import {
  formatTagsToString,
  prepareUIElements,
  registerTaskCallbacks,
  setupGlobalHandlers
} from './utils';
import dropdownHTML from '../../components/dropdownHTML';
import { TemplateResponsible } from './TemplateResponsible';

const renderResponsible = (props) => {
  setupGlobalHandlers();

  const {
    column,
    activities,
    gantt,
    t,
    onlyRead,
    task,
    callbackOnClickCreate,
    callbackOnClickRemove,
    callbackOnSelection,
    mainObject,
    customMainClassName
  } = props;

  if (!task.isTask || !gantt) return '';

  const taskFromLookahead = getTaskFromLookahead(activities, gantt, task.id);
  const { subtradeRole } = gantt;
  const isOnlyReadElement = getIsOnlyReadElement(onlyRead, task, subtradeRole);
  const selectedObject = { ...task, ...(mainObject || {}) };
  const optionsList = gantt.toSelectResponsables;

  const searchPlaceholder = formatTagsToString(selectedObject.responsables);

  registerTaskCallbacks(task.id, task, {
    taskFromLookahead,
    column,
    gantt,
    callbackOnSelection,
    callbackOnClickCreate,
    callbackOnClickRemove
  });

  const { placeholderHtml, optionsListHtml } = prepareUIElements({
    selectedObject,
    optionsList,
    isOnlyReadElement,
    t,
    column,
    taskId: task.id
  });

  const dropdownContent = `
    <ul class="options-list" onscroll="event.stopPropagation()">
      ${optionsListHtml}
    </ul>
  `;

  const dropdown = dropdownHTML({
    trigger: placeholderHtml,
    content: dropdownContent,
    width: column?.width,
    isReadOnly: isOnlyReadElement,
    id: `responsible-dropdown-${task.id}`,
    customClass: `custom-responsible-dropdown ${customMainClassName || ''}`,
    searchable: true,
    searchPlaceholder: searchPlaceholder
  });

  const isOdd = getIsOdd({ gantt, task }, 'responsible');

  return `
    <div 
      class="${isOdd ? 'odd-col' : 'non-odd-col'} ${customMainClassName || ''}"
      data-task-id="${task.id}"
      data-column-name="${column.name}">
      ${dropdown}
      ${TemplateResponsible(task)}
    </div>
  `;
};

export default renderResponsible;
